"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdjustmentSubmitComponent = void 0;
const core_1 = require("@angular/core");
const account_1 = require("./account");
const _ = require("lodash");
const moment = require('moment');
let AdjustmentSubmitComponent = class AdjustmentSubmitComponent {
    submit() {
        return __awaiter(this, void 0, void 0, function* () {
            let clients = account_1.Account.assemble(this.accounts);
            if (_.isEmpty(clients)) {
                account_1.Account.talk('No data to update');
                return;
            }
            try {
                yield account_1.Account.update({
                    demandPartner: this.demandPartner,
                    date: moment(this.date, "MMMM Do YYYY").startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    clients: clients
                });
            }
            catch (err) {
                err.join ? account_1.Account.talk(err.join('<br>')) : account_1.Account.talk(err);
            }
        });
    }
};
exports.AdjustmentSubmitComponent = AdjustmentSubmitComponent;
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Number)
], AdjustmentSubmitComponent.prototype, "demandPartner", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], AdjustmentSubmitComponent.prototype, "date", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Array)
], AdjustmentSubmitComponent.prototype, "accounts", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Boolean)
], AdjustmentSubmitComponent.prototype, "dspAsAccount", void 0);
exports.AdjustmentSubmitComponent = AdjustmentSubmitComponent = __decorate([
    (0, core_1.Component)({
        selector: 'adjustment-submit',
        templateUrl: 'app/adjustment-submit.component.html',
        styleUrls: ['styles/adjustment.component.css']
    })
], AdjustmentSubmitComponent);
//# sourceMappingURL=adjustment-submit.component.js.map